import { render, staticRenderFns } from "./TypeInfo.vue?vue&type=template&id=c31bda2a&scoped=true&"
import script from "./TypeInfo.vue?vue&type=script&lang=js&"
export * from "./TypeInfo.vue?vue&type=script&lang=js&"
import style0 from "./TypeInfo.vue?vue&type=style&index=0&id=c31bda2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31bda2a",
  null
  
)

export default component.exports